/**
 * Pieces the admin platform homes share (redesign 0.53.0): the router link and search pick handler
 * for the shell components, time wording (from the shared package), and the section cards under
 * the tasks.
 */

import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router';
import type { SearchItem, ShellLinkComponent, ShellNav } from '@retail-ops/panel-shell';

export { whenText, ageText, oldest } from '@retail-ops/panel-shell';

export const ShellLink = Link as unknown as ShellLinkComponent;

export function useSearchPick(): (item: SearchItem) => void {
  const navigate = useNavigate();
  return useCallback(
    (item: SearchItem) => {
      if (item.external) window.open(item.path, '_blank', 'noopener,noreferrer');
      else void navigate(item.path);
    },
    [navigate],
  );
}

/** The platform's sections as cards (each says how many pages it holds), under the tasks. */
export function SectionCards({ nav }: { nav: ShellNav }): JSX.Element | null {
  const sections = nav.sections.filter((s) => s.path);
  if (sections.length === 0) return null;
  return (
    <section aria-labelledby="ps-all-sections" className="ps-home__section">
      <h2 id="ps-all-sections" className="ps-home__h2">
        Everything in {nav.root.label}
      </h2>
      <div className="ps-page-grid">
        {sections.map((s) => (
          <Link key={s.id} to={s.path!} className="ps-page-card">
            <span className="ps-page-card__title">{s.label}</span>
            <span className="ps-page-card__help">
              {s.pages.length > 0 ? `${s.pages.length} page${s.pages.length === 1 ? '' : 's'}. ` : ''}
              {s.holds}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
